import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import { checkoutGotVehicleCode, checkoutRedirect, startCheckout } from '../../actions/app/checkout.actions'
import orderUrlSelector from '../../selectors/url/orderUrlSelector'
import { createVehicleCode, setVehicleCodeState } from '../../actions/app/vehicleCode.actions'
import vehicleCodeSelector from '../../selectors/vehicleCodeSelector'
import isTrampolineEnabledSelector from '../../selectors/feature-scope/isTrampolineEnabledSelector'
import isReturnUrlWithHeadersEnabledSelector from '../../selectors/feature-scope/isReturnUrlWithHeadersEnabledSelector'
import initParametersSelector from '../../selectors/initParametersSelector'
import {callOrderComplete} from "../../actions/app/orderComplete.actions"
import { traceLogger } from '../../../utils/dccLogger'

const checkoutMiddleware: Middleware = (store) => (next) => (action) => {
    next(action)
    const { dispatch, getState } = store

    if (isActionOf(startCheckout, action)) {
        dispatch(createVehicleCode(undefined, {
            onSuccess: checkoutGotVehicleCode,
        }))
    }

    if (isActionOf(checkoutGotVehicleCode, action)) {
        const { vehicleCode } = action.payload
        const state = getState()
        const returnUrlWithHeaderEnabled = isReturnUrlWithHeadersEnabledSelector(state)

        dispatch(setVehicleCodeState(vehicleCode))
        if (returnUrlWithHeaderEnabled) {
            dispatch(callOrderComplete())
        } else {
            dispatch(checkoutRedirect())
        }
    }

    if (isActionOf(checkoutRedirect, action)) {
        const state = getState()
        const orderUrl = orderUrlSelector(state)
        const vehicleCode = vehicleCodeSelector(state)
        const returnUrlWithHeaderEnabled = isReturnUrlWithHeadersEnabledSelector(state)
        const trampolineIsEnabled = isTrampolineEnabledSelector(state)

        if (!trampolineIsEnabled && !returnUrlWithHeaderEnabled) {
            const targetUrl = `${orderUrl}${vehicleCode}`

            traceLogger.info(`Checkout return URL: ${targetUrl}`)

            window.location.href = targetUrl
        } else {
            const { entryUrl } = initParametersSelector(state)
            const parsedUrl = new URL(entryUrl)
            const searchParams = new URLSearchParams(parsedUrl.search)

            const dealerNumber = searchParams.get('dealer_number') || ''
            const salesmanNumber = searchParams.get('salesman_number') || ''
            const context = searchParams.get('context')
            const mandant = searchParams.get('mandant')

            const baseUrl = parsedUrl.pathname === "/"
                ? parsedUrl.origin
                : `${parsedUrl.origin}${parsedUrl.pathname}`

            const updatedParams = new URLSearchParams()

            let url = `${baseUrl}/checkout?`

            if (context) {
                url = url + `context=${context}&`
            } else if (mandant) {
                url = url + `mandant=${mandant}&`
            }

            updatedParams.set('audicode', vehicleCode)
            updatedParams.set('dealer_number', dealerNumber)
            updatedParams.set('salesman_number', salesmanNumber)
            updatedParams.set('configuration_process', 'finished')

            const targetUrl = `${url}${updatedParams.toString()}`

            traceLogger.info(`Checkout return URL: ${targetUrl}`)

            window.location.href = targetUrl
        }
    }
}

export default checkoutMiddleware
